import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import { ConfigProvider, theme, Table, Input, } from 'antd';
import type { ColumnsType } from "antd/es/table";
import { Minus, Plus, User, ClipboardPlus, Play, File, CloudUpload, PencilLine, CircleChevronDown, SlidersHorizontal, Funnel, SquareArrowOutUpRight, } from 'lucide-react';

import Layout from '../../Layout'; // Giữ nguyên import layout của bạn
import { Link } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { Segmented } from "antd";


const { TextArea } = Input;

export default function InventoryDetail() {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [rightTab, setRightTab] = useState("inventory");

    // ====Collapse States======
    const [expandedBlocks, setExpandedBlocks] = useState({
        general: true,
        seriList: true,
        inventoryHistory: true,

        inventory: true,
        history: true,
        settings: true,
    });

    const toggleBlock = (key: keyof typeof expandedBlocks) => {
        setExpandedBlocks(prev => ({ ...prev, [key]: !prev[key] }));
    };

    //==== SelectRow cua Seri List=====
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys: React.Key[]) => setSelectedRowKeys(keys),
    };

    // Định nghĩa cột
    const columns: ColumnsType<(typeof reportData)[number]> = [
        {
            title: "Người tạo",
            dataIndex: "user",
            key: "user",
            align: "center",
            render: (_, record) => {
                if (record.user === "--") {
                    return (
                        <span className="text-slate-400 dark:text-slate-500">--</span>
                    );
                }

                return record.avatarUrl ? (
                    <img
                        src={record.avatarUrl}
                        alt="avatar"
                        className="w-6 h-6 rounded object-cover mx-auto bg-orange-500 p-0.5"
                    />
                ) : (
                    <div className="w-6 h-6 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center mx-auto">
                        <User className="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                    </div>
                );
            },
        },
        {
            title: "Seri/imei",
            dataIndex: "seri",
            key: "seri",
            align: "center",
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (text: any) => (
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400">{text}</span>
            ),
        },
        {
            title: "Sản phẩm",
            dataIndex: "product",
            key: "product",
            align: "center",
        },
        {
            title: "Kho",
            dataIndex: "kho",
            key: "kho",
            align: "center",
        },
        {
            title: "Ngày tạo",
            dataIndex: "date",
            key: "date",
            align: "center",
        },

    ];

    const columns1: ColumnsType<(typeof reportData1)[number]> = [
        {
            title: "Phát sinh",
            dataIndex: "type",
            key: "type",
            align: "center",
        },
        {
            title: "Mã phiếu",
            dataIndex: "code",
            key: "code",
            align: "center",
        },
        {
            title: "Kho nhận",
            dataIndex: "warehouse",
            key: "warehouse",
            align: "center",
        },
        {
            title: "Đơn vị",
            dataIndex: "unit",
            key: "unit",
            align: "center",
        },
        {
            title: "Nhập kho",
            dataIndex: "importQuantity",
            key: "importQuantity",
            align: "center",
            render: (value: number | null) =>
                value != null
                    ? `${value.toLocaleString("vi-VN")}`
                    : "--",
        },
        {
            title: "Xuất kho",
            dataIndex: "exportQuantity",
            key: "exportQuantity",
            align: "center",
            render: (value: number | null) =>
                value != null
                    ? `${value.toLocaleString("vi-VN")}`
                    : "--",
        },
        {
            title: "Tồn cuối kỳ",
            dataIndex: "endingQuantity",
            key: "endingQuantity",
            align: "center",
            render: (value: number | null) =>
                value != null
                    ? `${value.toLocaleString("vi-VN")}`
                    : "--",
        },
        {
            title: "Đơn giá",
            dataIndex: "price",
            key: "price",
            align: "center",
            render: (value: number | null) =>
                value != null
                    ? `${value.toLocaleString("vi-VN")}₫`
                    : "--",
        },
        {
            title: "Thời gian",
            dataIndex: "date",
            key: "date",
            align: "center",
        },
        {
            title: "Người tạo",
            dataIndex: "user",
            key: "user",
            align: "center",
            render: (_: any, record: any) => {
                if (record.user === "--") {
                    return (
                        <span className="text-slate-400 dark:text-slate-500">
                            --
                        </span>
                    );
                }

                return record.avatarUrl ? (
                    <img
                        src={record.avatarUrl}
                        alt="avatar"
                        className="w-6 h-6 rounded-full object-cover mx-auto"
                    />
                ) : (
                    <div className="w-6 h-6 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center mx-auto">
                        <User className="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                    </div>
                );
            },
        },
        {
            title: "Mô tả",
            dataIndex: "description",
            key: "description",
            align: "center",
        },
    ];

    // ================= MOCK DATA BẢNG =================
    const reportData = [
        {
            key: 1,
            id: 1,
            seri: '1905-02',
            product: "SP.0876188 - Bảng học sinh",
            kho: 'Kho văn phòng phẩm',
            date: '19/05/2026',
            status: 'Chưa bán',
            user: "--",
        },
        {
            key: 2,
            id: 2,
            seri: '1905-01',
            product: "SP.0876188 - Bảng học sinh",
            kho: 'Kho văn phòng phẩm',
            date: '19/05/2026',
            status: 'Chưa bán',
            user: "avatar",
            avatarUrl: "https://api.dicebear.com/7.x/bottts/svg?seed=1",
        },
    ];
    const reportData1 = [
        {
            key: 1,
            id: 1,
            type: "Nhập kho",
            code: "PNK_2026_400",
            warehouse: "",
            unit: "Cái",
            importQuantity: 100000,
            exportQuantity: null,
            endingQuantity: 100000,
            price: 5000,
            date: "19/05/2021",
            user: "--",
            description: "",
        },
        {
            key: 2,
            id: 2,
            type: "Nhập kho",
            code: "PNK_2026_400",
            warehouse: "-",
            unit: "Cái",
            importQuantity: 10000,
            exportQuantity: null,
            endingQuantity: 110000,
            price: 5000,
            date: "19/05/2021",
            user: "--",
            description: "-",
        },
    ];

    // ================= THEME & UI COMPONENTS =================
    const antdThemeConfig = {
        token: {
            colorPrimary: '#3e91ab',
            colorBgContainer: isDarkMode ? '#1f2937' : '#ffffff',
            colorText: isDarkMode ? '#f3f4f6' : '#374151',
            colorBorder: isDarkMode ? '#4b5563' : '#d1d5db',
            borderRadius: 6,
        },
        components: { Table: { headerBg: isDarkMode ? '#374151' : '#f9fafb' } },
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    };

    const CardHeader = ({ title, blockKey, extra }: { title: any, blockKey: keyof typeof expandedBlocks, extra?: any }) => (
        <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-4 py-2 -mx-4 -mt-4 rounded-t-lg">
            <h3 className="font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
            <div className="flex items-center gap-3">
                {extra}
                <div onClick={() => toggleBlock(blockKey)} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                    {expandedBlocks[blockKey] ? <Minus size={16} /> : <Plus size={16} />}
                </div>
            </div>
        </div>
    );

    // const CardHeaderRight = ({ title, blockKey, filter }) => (
    //     <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-4 py-2 -mx-4 -mt-4 rounded-t-lg">
    //         <h3 className="font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
    //         <div className='flex gap-3'>
    //             {filter && (
    //                 <div className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
    //                     <Funnel size={16} />
    //                 </div>
    //             )}
    //             <div onClick={() => toggleBlockRight(blockKey)} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
    //                 {expandedBlocksRight[blockKey] ? <Minus size={16} /> : <Plus size={16} />}
    //             </div>
    //         </div>
    //     </div>
    // );

    return (
        <Layout>
             <Helmet>
                <title> Chi tiết sản phẩm | Khothi</title>
            </Helmet>
            <ConfigProvider theme={antdThemeConfig}>
                <div className={`min-h-screen pb-10 transition-colors duration-300`}>

                    {/* --- HEADER ACTIONS --- */}
                    <div className="border-b dark:border-gray-700 px-4 md:px-6 py-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">
                        <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                            <div className="flex sm:items-center gap-4 text-sm items-start">
                                <Link to="/inventory" className="flex items-center gap-2">
                                    <LeftOutlined className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white" />
                                </Link>
                                <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-1 cursor-pointer">Chi tiết</span>
                            </div>
                        </div>

                        <div className='overflow-x-auto no-scrollbar'>
                            <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max text-000000e0">
                                <button className="text-sm flex items-center gap-1.5 hover:text-[#3e91ab]"><ClipboardPlus size={14} /> Seri/imei</button>
                                <button className="text-sm flex items-center gap-1.5 hover:text-[#3e91ab]"><Play size={14} /> Trạng thái</button>
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><File size={14} /> Biểu mẫu</button>
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><CloudUpload size={14} /> Tải lên</button>
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><PencilLine size={14} /> Sửa</button>
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><CircleChevronDown size={20} /></button>
                            </div>
                        </div>
                    </div>

                    {/* --- MAIN LAYOUT --- */}
                    <div className="mx-auto mt-4 grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-4">

                        {/* CỘT TRÁI CÓ TABS CHÍNH */}
                        <div className="overflow-hidden">
                            <div className="flex flex-col gap-6 pt-0">

                                {/* 1. THÔNG TIN CHUNG */}
                                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                    <CardHeader title="Thông tin chung" blockKey="general" />
                                    {expandedBlocks.general && (
                                        <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-y-6 gap-x-4 md:gap-x-8 text-sm animate-in fade-in duration-300 mt-2">
                                            <div className="bg-gray-50 dark:bg-gray-700 h-64 rounded flex flex-col items-center justify-center relative border border-gray-100 dark:border-gray-600">
                                                {/* Icon / Text No Product Image */}
                                                <div className="text-center text-gray-400">
                                                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-gray-400">
                                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                                        <circle cx="8.5" cy="8.5" r="1.5"></circle>
                                                        <polyline points="21 15 16 10 5 21"></polyline>
                                                    </svg>
                                                    <span className="text-xs font-bold tracking-wide text-gray-400">NO PRODUCT IMAGE</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Barcode</p>
                                                    <p className="text-gray-900 dark:text-gray-200">---</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Mã sản phẩm</p>
                                                    <p className="text-gray-900 dark:text-gray-200">SP.087E8</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Tên sản phẩm</p>
                                                    <p className="text-gray-900 dark:text-gray-200">Bảng</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Loại hàng hóa</p>
                                                    <p className="text-gray-900 dark:text-gray-200">---</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Đơn vị</p>
                                                    <p className="text-gray-900 dark:text-gray-200">Cái</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Nhóm sản phẩm</p>
                                                    <p className="text-gray-900 dark:text-gray-200">---</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Giá vốn mặc định</p>
                                                    <p className="text-gray-900 dark:text-gray-200">₫</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Giá bán mặc định</p>
                                                    <p className="text-gray-900 dark:text-gray-200">₫</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Sử dụng cho</p>
                                                    <p className="text-gray-900 dark:text-gray-200">Chỉ bán</p>
                                                </div>

                                                <div>
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Trạng thái</p>
                                                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400">Hoạt động</span>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Phòng ban áp dụng</p>
                                                    <p className="text-gray-900 dark:text-gray-200">---</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Thông tin sản phẩm</p>
                                                    <p className="text-gray-900 dark:text-gray-200">---</p>
                                                </div>

                                                <div className="col-span-1 md:col-span-2">
                                                    <p className="text-gray-500 dark:text-gray-400 mb-1">Tồn kho</p>
                                                    <p className="text-gray-900 dark:text-gray-200">Kho Văn Phòng Phẩm: 5 (Cái)</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* 2. DANH SÁCH SERI */}
                                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                    <CardHeader title="Danh sách seri/imei" blockKey="seriList" />
                                    {expandedBlocks.seriList && (
                                        <div className="animate-in fade-in duration-300">
                                            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-900">
                                                <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 text-xs">
                                                    <SlidersHorizontal className="w-4 h-4" />
                                                    {selectedRowKeys.length > 0 ? (
                                                        <span>
                                                            Đã chọn <b>{selectedRowKeys.length}</b> bản ghi
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            Hiển thị 1 - {reportData.length} / {reportData.length} bản ghi
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Ant Design Table */}
                                            <div className="py-4">
                                                <ConfigProvider
                                                    theme={{
                                                        components: {
                                                            Table: {
                                                                headerBg: "#f8f9fa",
                                                                headerColor: "#6b7280",
                                                                cellPaddingBlock: 12,
                                                                rowHoverBg: "#eff6ff",
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <Table
                                                        rowSelection={rowSelection}
                                                        columns={columns}
                                                        dataSource={reportData}
                                                        pagination={false}
                                                        scroll={{ x: "max-content" }}
                                                    />
                                                </ConfigProvider>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* 3. ĐIỀU KHOẢN THANH TOÁN */}
                                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                    <CardHeader title="Lịch sử xuất nhập kho" blockKey="inventoryHistory" />
                                    {expandedBlocks.inventoryHistory && (
                                        <div className="overflow-x-auto animate-in fade-in duration-300">
                                            <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                                                <div className="flex sm:items-center gap-4 text-sm items-start">
                                                    <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-1 cursor-pointer">{`Tất cả (${reportData1.length})`}</span>
                                                </div>
                                                <span className="text-gray-500 dark:text-gray-400 pb-1 font-medium">Office.02 - Kho văn phòng phẩm (02)</span>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 px-4 py-3 border-b border-t border-gray-200 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-900">
                                                <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 text-xs">
                                                    <span>
                                                        Hiển thị 1 - {reportData.length} / {reportData.length} bản ghi
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Ant Design Table */}
                                            <div className="py-4">
                                                <ConfigProvider
                                                    theme={{
                                                        components: {
                                                            Table: {
                                                                headerBg: "#f8f9fa",
                                                                headerColor: "#6b7280",
                                                                cellPaddingBlock: 12,
                                                                rowHoverBg: "#eff6ff",
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <Table
                                                        columns={columns1}
                                                        dataSource={reportData1}
                                                        pagination={false}
                                                        scroll={{ x: "max-content" }}
                                                    />
                                                </ConfigProvider>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>

                        {/* CỘT PHẢI (THẢO LUẬN / LỊCH SỬ) - Giữ nguyên logic cũ */}
                        <div className="flex flex-col gap-4 h-full">
                            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-4 py-2 -mx-4 -mt-4 rounded-t-lg">
                                    <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                                        <div className="flex sm:items-center gap-4 text-sm items-start">
                                            <button
                                                type="button"
                                                onClick={() => setRightTab("inventory")}
                                                className={`font-medium pb-1 border-b-2 transition-colors ${rightTab === "inventory"
                                                    ? "text-[#3e91ab] border-[#3e91ab]"
                                                    : "text-gray-500 dark:text-gray-400 border-transparent"
                                                    }`}
                                            >
                                                Tồn kho
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setRightTab("discussion")}
                                                className={`font-medium pb-1 border-b-2 transition-colors ${rightTab === "discussion"
                                                    ? "text-[#3e91ab] border-[#3e91ab]"
                                                    : "text-gray-500 dark:text-gray-400 border-transparent"
                                                    }`}
                                            >
                                                Thảo luận
                                            </button>
                                        </div>
                                    </div>
                                    <div onClick={() => toggleBlock('inventory')} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                                        {expandedBlocks['inventory'] ? <Minus size={16} /> : <Plus size={16} />}
                                    </div>
                                </div>
                                {expandedBlocks.inventory && (
                                    // <Tabs
                                    //     defaultActiveKey="1"
                                    //     className="px-4 pt-2 flex-1 flex flex-col"
                                    //     items={[
                                    //         {
                                    //             key: '1',
                                    //             label: 'Thảo luận',
                                    //             children: (
                                    //                 <div className="flex flex-col h-full mt-2">
                                    //                     <div className="flex-1 overflow-y-auto mb-4 pr-2 max-h-[500px]">
                                    //                         {comments.map(comment => (
                                    //                             <div key={comment.id} className="flex gap-3 mb-6">
                                    //                                 <Avatar style={{ backgroundColor: '#84cc16' }}>{comment.author.charAt(0)}</Avatar>
                                    //                                 <div className="flex-1">
                                    //                                     <div className="flex justify-between items-start">
                                    //                                         <div className="w-full">
                                    //                                             <span className="font-semibold text-gray-800 dark:text-gray-200 text-sm">{comment.author}</span>
                                    //                                             {editingId === comment.id ? (
                                    //                                                 <div className="mt-1 flex gap-2 w-full max-w-sm">
                                    //                                                     <Input value={editValue} onChange={(e) => setEditValue(e.target.value)} onPressEnter={() => saveEdit(comment.id)} size="small" autoFocus />
                                    //                                                     <Button size="small" type="primary" onClick={() => saveEdit(comment.id)} className="bg-[#3e91ab]">Lưu</Button>
                                    //                                                     <Button size="small" onClick={() => setEditingId(null)}>Hủy</Button>
                                    //                                                 </div>
                                    //                                             ) : (
                                    //                                                 <div className="bg-gray-100 dark:bg-gray-700/50 p-3 rounded-lg rounded-tl-none mt-1 text-sm text-gray-800 dark:text-gray-200 border dark:border-gray-700 w-fit w-full">
                                    //                                                     {comment.text}
                                    //                                                 </div>
                                    //                                             )}
                                    //                                         </div>
                                    //                                         <Dropdown menu={{ items: [{ key: 'edit', label: 'Sửa', onClick: () => startEdit(comment.id, comment.text) }, { key: 'delete', label: 'Xóa', danger: true, onClick: () => handleDeleteComment(comment.id) }] }} trigger={['click']} placement="bottomRight">
                                    //                                             <MoreVertical size={16} className="text-gray-400 cursor-pointer hover:text-gray-600 ml-2 mt-1" />
                                    //                                         </Dropdown>
                                    //                                     </div>
                                    //                                     <div className="flex items-center gap-4 mt-2 text-xs text-gray-500 dark:text-gray-400">
                                    //                                         <span>{comment.time}</span><span className="cursor-pointer hover:text-[#3e91ab]">Thích</span><span className="cursor-pointer hover:text-[#3e91ab]">Trả lời</span>
                                    //                                     </div>
                                    //                                 </div>
                                    //                             </div>
                                    //                         ))}
                                    //                     </div>
                                    //                     <div className="border dark:border-gray-600 rounded-lg p-3 bg-gray-50 dark:bg-gray-700/30 shrink-0 mb-4">
                                    //                         <Input bordered={false} placeholder="Viết thảo luận..." className="mb-2 dark:text-gray-200" value={inputValue} onChange={(e) => setInputValue(e.target.value)} onPressEnter={handleSendComment} />
                                    //                         <div className="flex justify-between items-center text-gray-400">
                                    //                             <div className="flex gap-3"><Paperclip size={16} className="cursor-pointer hover:text-[#3e91ab]" /><Smile size={16} className="cursor-pointer hover:text-[#3e91ab]" /></div>
                                    //                             <Send size={16} className="cursor-pointer text-[#3e91ab]" onClick={handleSendComment} />
                                    //                         </div>
                                    //                     </div>
                                    //                 </div>
                                    //             )
                                    //         },
                                    //         {
                                    //             key: '2',
                                    //             label: 'Lịch sử hoạt động',
                                    //             children: (
                                    //                 <div className="mt-4">
                                    //                     <div className="relative pl-6 border-l border-gray-200 dark:border-gray-600 ml-4 pb-6">
                                    //                         <div className="absolute -left-[16px] top-0 bg-white dark:bg-gray-800 rounded-full p-0.5">
                                    //                             <Avatar style={{ backgroundColor: '#84cc16' }} size={28} className="text-xs">H</Avatar>
                                    //                         </div>
                                    //                         <div className="pt-0.5">
                                    //                             <div className="text-sm dark:text-gray-300">
                                    //                                 <span className="font-semibold text-gray-800 dark:text-gray-200">Mr. Huấn</span> đã duyệt
                                    //                             </div>
                                    //                             <div className="text-xs text-gray-400 mb-2 mt-0.5">11:42 ngày 22/08/2026</div>
                                    //                             <div className="bg-[#f8fafc] dark:bg-gray-700/30 p-3 rounded-md text-sm text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700">
                                    //                                 Bước: Admin hệ thống duyệt
                                    //                             </div>
                                    //                         </div>
                                    //                     </div>
                                    //                     <div className="relative pl-6 border-l border-gray-200 dark:border-gray-600 ml-4 pb-6">
                                    //                         <div className="absolute -left-[16px] top-0 bg-white dark:bg-gray-800 rounded-full p-0.5">
                                    //                             <Avatar style={{ backgroundColor: '#84cc16' }} size={28} className="text-xs">H</Avatar>
                                    //                         </div>
                                    //                         <div className="pt-0.5">
                                    //                             <div className="text-sm dark:text-gray-300">
                                    //                                 <span className="font-semibold text-gray-800 dark:text-gray-200">Mr. Huấn</span> đã tạo hợp đồng
                                    //                             </div>
                                    //                             <div className="text-xs text-gray-400 mb-2 mt-0.5">10:49 ngày 22/08/2026</div>
                                    //                         </div>
                                    //                     </div>
                                    //                 </div>
                                    //             )
                                    //         }
                                    //     ]}
                                    // />
                                    rightTab === "inventory" ? (
                                        <span className="text-gray-500 dark:text-gray-400 text-sm">Không tìm thấy kết quả nào</span>
                                    ) : (
                                        <span className="text-gray-500 dark:text-gray-400 text-sm">Không tìm thấy kết quả nào!!</span>
                                    )
                                )}
                            </div>

                            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                <CardHeader
                                    title="Lịch sử hoạt động"
                                    blockKey="history"
                                    extra={<Funnel size={16} className="cursor-pointer text-gray-400 hover:text-[#3e91ab]" />}
                                />

                                {expandedBlocks.history && (
                                    <div className="pb-4 mt-4">
                                        {/* Khung chứa Timeline */}
                                        <div className="relative pl-6 space-y-4 max-h-[450px] overflow-y-auto pr-1">

                                            {/* Trục dọc (Đường line màu xám chạy dọc timeline) */}
                                            <div className="absolute left-[11px] top-3 bottom-3 w-0.5 bg-gray-200 dark:bg-gray-700"></div>

                                            {/* --- ITEM TIMELINE 1 --- */}
                                            <div className="relative flex items-start group">
                                                {/* Icon tròn màu hồng đậm bên trái */}
                                                <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#ec4899] text-white flex items-center justify-center shadow-sm z-9">
                                                    <PencilLine size={12} />
                                                </div>
                                                {/* Card nội dung */}
                                                <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                    <div className="flex justify-between items-start">
                                                        <div>
                                                            <div className='flex gap-1 items-center'>
                                                                <p className="text-sm text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">Admin Hệ thống</span> <span className="text-gray-500">đã sửa</span>
                                                                </p>
                                                                <SquareArrowOutUpRight size={12} color='#4577D2' />
                                                            </div>
                                                            <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                <span className="mr-1"></span> 17:26 ng 25/06/2026
                                                            </p>
                                                            <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                ID: 3443 - Bang hoc sinh
                                                            </p>
                                                        </div>
                                                        {/* Avatar chữ B bên phải */}
                                                        <div className="w-8 h-8 rounded-full bg-gray-400 text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                            B
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* --- ITEM TIMELINE 3 --- */}
                                            <div className="relative flex items-start group">
                                                {/* Icon tròn màu xanh lá bên trái */}
                                                <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#10b981] text-white flex items-center justify-center shadow-sm z-9">
                                                    <Plus size={12} />
                                                </div>
                                                {/* Card nội dung */}
                                                <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                    <div className="flex justify-between items-start">
                                                        <div>
                                                            <div className='flex gap-1 items-center'>
                                                                <p className="text-sm text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">Admin Hệ thống</span> <span className="text-gray-500">đã tạo mới</span>
                                                                </p>
                                                                <SquareArrowOutUpRight size={12} color='#4577D2' />
                                                            </div>
                                                            <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                <span className="mr-1"></span> 17:25 ng 25/06/2026
                                                            </p>
                                                            <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                ID: 3443 - Bang hoc sinh
                                                            </p>
                                                        </div>
                                                        {/* Avatar chữ B bên phải */}
                                                        <div className="w-8 h-8 rounded-full bg-gray-400 text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                            B
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )}

                            </div>

                            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                <CardHeader title="Trường tùy chỉnh" blockKey="settings" />

                                {expandedBlocks.settings && (
                                    <div className="col-span-1 md:col-span-2 text-sm">
                                        <p className="text-gray-500 dark:text-gray-400 mb-1">Lô sản phẩm</p>
                                        <p className="text-gray-900 dark:text-gray-200">---</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </ConfigProvider>
        </Layout>
    );
}